import type { PlanType, TierLimits } from '../types';

export const API_VERSION = 'v1' as const;
export const API_BASE_PATH = `/api/${API_VERSION}` as const;

export const API_ROUTES = {
  GENERATE_QUESTIONS: `${API_BASE_PATH}/questions/generate`,
  SUBSCRIPTION_ME: `${API_BASE_PATH}/subscriptions/me`,
  SUBSCRIPTION_CANCEL: `${API_BASE_PATH}/subscriptions/cancel`,
  PAYMENT_INITIATE: `${API_BASE_PATH}/payments/initiate`,
  PAYMENT_HISTORY: `${API_BASE_PATH}/payments/history`,
  PAYMENT_IPN: `${API_BASE_PATH}/payments/ipn`,
  ADMIN_USERS: `${API_BASE_PATH}/admin/users`,
  ADMIN_ACTIVITY: `${API_BASE_PATH}/admin/activity`,
  ADMIN_STATS: `${API_BASE_PATH}/admin/stats`,
  ADMIN_USER_BAN: (userId: string) => `${API_BASE_PATH}/admin/users/${userId}/ban`,
  ADMIN_USER_UNBAN: (userId: string) => `${API_BASE_PATH}/admin/users/${userId}/unban`,
} as const;

/** Offered in the admin ban dialog; any 1–3650 day value is accepted by the API. */
export const BAN_DURATION_DAYS = [1, 7, 30] as const;

/** Caps `pageSize` on the admin list endpoints so a hand-written query cannot pull the whole table. */
export const ADMIN_PAGE_SIZE_MAX = 100;
export const ADMIN_PAGE_SIZE_DEFAULT = 25;

export const TIER_LIMITS: Record<PlanType, TierLimits> = {
  free_trial: { pdfsPerMonth: 1, maxWritten: 3, maxMCQ: 10 },
  pro_trial: { pdfsPerMonth: 20, maxWritten: 6, maxMCQ: 30 },
  pro: { pdfsPerMonth: 40, maxWritten: 6, maxMCQ: 30 },
  institution: { pdfsPerMonth: 1000, maxWritten: 100, maxMCQ: 100 },
};

export const PLAN_DURATIONS: Record<PlanType, number> = {
  free_trial: 14,
  pro_trial: 30,
  pro: 30,
  institution: 30,
};

export const PLAN_PRICES: Record<Exclude<PlanType, 'free_trial' | 'institution'>, number> = {
  pro_trial: 499,
  pro: 899,
};

export const PLAN_NAMES: Record<PlanType, string> = {
  free_trial: 'Free Trial',
  pro_trial: 'Pro Trial',
  pro: 'Pro',
  institution: 'Institution',
};

export const PURCHASABLE_PLANS = ['pro_trial', 'pro'] as const;
export type PurchasablePlan = (typeof PURCHASABLE_PLANS)[number];
